import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http:HttpClient) { }

  getAdmin(data:any){
    return this.http.post(environment.apiUrl + "admin/get/all", data)
  }


  updateAdmin(data:any){
    return this.http.post(environment.apiUrl + "admin/update" , data)
  }

  addAdmin(data:any){
    return this.http.post(environment.apiUrl + "admin/addNew" , data)

  }

}
